import * as properties from './properties';
import * as datatypes from './datatypes';
import * as units from './units';

export const meta = {
	properties,
	datatypes,
	units
};